import { createPlatePlugin } from 'platejs/react'
import type { AnyPlatePlugin } from 'platejs/react'

import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'

import { unwrapGeneratedContent } from './commands/unwrapGeneratedContent'
import { GenerateContentElement } from './nodes/GenerateContentElement'
import { GenerateContentElementUI } from './ui/GenerateContentElementUI'
import { withGeneratedContent } from './withGeneratedContent'

export const checkSelection = (ctx: { editor: unknown }): void => {
  const editor = ctx.editor as BufferEditor
  editor.highlighted = editor.selection
    ? editor.api.string(editor.selection)
    : null
}

export const processGeneratedContent = (ctx: { editor: unknown }): void => {
  const editor = ctx.editor as BufferEditor
  unwrapGeneratedContent({ editor })
}

// NOTE: This plugin will be removed once the current AI Assistant is
// removed in favor of AI Assistant 2.0
//
// Not returned directly from the arrow function: an explicit return type on
// the expression itself back-propagates into createPlatePlugin's own
// generic inference and corrupts it (options/node end up typed against the
// annotation's defaults instead of the literal passed in).
export const createGenerateContentPlugin = (): AnyPlatePlugin => {
  const plugin = createPlatePlugin({
    key: GenerateContentElement.type,
    node: {
      isElement: true,
      component: GenerateContentElementUI,
    },
    extendEditor: ({ editor }) =>
      withGeneratedContent(editor as unknown as BufferEditor),
    handlers: {
      onKeyDown: processGeneratedContent,
      onMouseUp: processGeneratedContent,
      onChange: checkSelection,
      onFocus: checkSelection,
    },
  })
  return plugin
}
